import React, { useState, useRef, useEffect } from "react";
import { Stage, Layer, Line, Circle, Text, Image } from "react-konva";
import {getNextRoiName} from '../../../../../../../utils/formatDate'

const GetCoordinates = ({ imgSrc, setCordinates,Cordinates,setFinalRoiSelection }) => {
  const stageRef = useRef(null);
  const containerRef = useRef(null);
  const [selections, setSelections] = useState([]);
  const [currentPoints, setCurrentPoints] = useState([]);
  const [imageSize, setImageSize] = useState({ width: 1, height: 1 });
  const [konvaImage, setKonvaImage] = useState(null);
  const [originalSize, setOriginalSize] = useState({ width: 1, height: 1 });
  const [ROICounts, setROICounts] = useState(1)

  useEffect(() => {
    const img = new window.Image();
    img.src = imgSrc;
    console.log("width",img.width)
    console.log("height",img.height)
    img.onload = () => {
      setOriginalSize({ width: img.width, height: img.height });
      setKonvaImage(img);
      updateImageSize();
    };

    window.addEventListener("resize", updateImageSize);
    return () => window.removeEventListener("resize", updateImageSize);
  }, [imgSrc]);

  const updateImageSize = () => {
    if (!containerRef.current) return;
    const containerWidth = containerRef.current.clientWidth;
    const containerHeight = window.innerHeight * 0.8; // Max height fix
    const aspectRatio = originalSize.width / originalSize.height;

    let newWidth = containerWidth;
    let newHeight = newWidth / aspectRatio;

    if (newHeight > containerHeight) {
      newHeight = containerHeight;
      newWidth = newHeight * aspectRatio;
    }

    setImageSize({ width: newWidth, height: newHeight });
  };

  const handleCanvasClick = (e) => {
    if (!stageRef.current) return;

    const stage = stageRef.current.getStage();
    const pointer = stage.getPointerPosition();
    if (!pointer) return;

    const stageX = stage.x();
    const stageY = stage.y();
    const scaleX = stage.scaleX();
    const scaleY = stage.scaleY();

    // Adjusting for transformations
    const adjustedX = (pointer.x - stageX) / scaleX;
    const adjustedY = (pointer.y - stageY) / scaleY;

    // Scaling to original image size
    const scaledX = (adjustedX / imageSize.width) * originalSize.width;
    const scaledY = (adjustedY / imageSize.height) * originalSize.height;
  
    const formattedPoints = currentPoints
      .map((_, i, arr) => (i % 2 === 0 ? { x: arr[i], y: arr[i + 1] } : null))
      .filter(Boolean);

    if (formattedPoints.length >= 3) {
      const firstX = formattedPoints[0].x;
      const firstY = formattedPoints[0].y;
      const distance = Math.sqrt((firstX - scaledX) ** 2 + (firstY - scaledY) ** 2);

      if (distance < 10) {
        // console.log("Selection Closed. Points:", formattedPoints);
        const newSelection = {
          coordinates: [...formattedPoints, { x: firstX, y: firstY }],
          name: `R${ROICounts}`,
          id :Math.floor(100 + Math.random() * 900),
        };

        const updatedSelections = [...selections, newSelection];
        setSelections(updatedSelections);
        setCordinates(updatedSelections);
        console.log(updatedSelections)
        setCurrentPoints([]);
        setROICounts(prev => prev + 1)
        return;
      }
    }
    
    setCurrentPoints([...currentPoints, scaledX, scaledY]);
  };
useEffect(() => {
    setSelections(Cordinates);
    if(Cordinates?.length<=0){
      setROICounts(1)
    }
    else{
      setROICounts( getNextRoiName(Cordinates) )
    }
    console.log(Cordinates)
}, [Cordinates])
  return (
    <div
      ref={containerRef}
      style={{
        width: "100%",
        height: "80vh", // Max height fix for no scrolling
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden", // Prevent extra scrolling
      }}
    >
      <Stage
        ref={stageRef}
        width={imageSize.width}
        height={imageSize.height}
        onClick={handleCanvasClick}
      >
        <Layer>
          {konvaImage && (
            <Image image={konvaImage} width={imageSize.width} height={imageSize.height} />
          )}

          {selections.map((selection, idx) => {
            const pointsArray = selection.coordinates.map(({ x, y }) => [
              (x / originalSize.width) * imageSize.width,
              (y / originalSize.height) * imageSize.height,
            ]).flat();
            // console.log(x,"x")
            // console.log(y,"y")
            const firstPoint = selection.coordinates[0];

            return (
              <React.Fragment key={idx}>
                <Line points={pointsArray} stroke="blue" strokeWidth={2} closed />
                <Text
                  x={(firstPoint.x / originalSize.width) * imageSize.width}
                  y={(firstPoint.y / originalSize.height) * imageSize.height}
                  text={selection.name}
                  fontSize={16}
                  fill="red"
                  fontStyle="bold"
                />
              </React.Fragment>
            );
          })}

          {currentPoints.length > 2 && (
            <Line
              points={currentPoints.map((p, i) =>
                i % 2 === 0
                  ? (p / originalSize.width) * imageSize.width
                  : (p / originalSize.height) * imageSize.height
              )}
              stroke="red"
              strokeWidth={2}
            />
          )}

          {currentPoints.map((point, index) =>
            index % 2 === 0 ? (
              <Circle
                key={index}
                x={(point / originalSize.width) * imageSize.width}
                y={(currentPoints[index + 1] / originalSize.height) * imageSize.height}
                radius={5}
                fill="red"
              />
            ) : null
          )}
        </Layer>
      </Stage>
    </div>
  );
};

export default GetCoordinates;




// import React, { useState, useRef, useEffect } from "react";
// import { Stage, Layer, Line, Circle, Text, Image } from "react-konva";
// import { getNextRoiName } from "../../../../../../../utils/formatDate";

// const GetCoordinates = ({ imgSrc, setCordinates, Cordinates, setFinalRoiSelection }) => {
//   const stageRef = useRef(null);
//   const containerRef = useRef(null);
//   const [selections, setSelections] = useState([]);
//   const [currentPoints, setCurrentPoints] = useState([]);
//   const [imageSize, setImageSize] = useState({ width: 1, height: 1 });
//   const [konvaImage, setKonvaImage] = useState(null);
//   const [originalSize, setOriginalSize] = useState({ width: 1, height: 1 });
//   const [ROICounts, setROICounts] = useState(1);

//   useEffect(() => {
//     const img = new window.Image();
//     img.src = imgSrc;
//     img.onload = () => {
//       setOriginalSize({ width: img.width, height: img.height });
//       setKonvaImage(img);
//       updateImageSize();
//     };

//     window.addEventListener("resize", updateImageSize);
//     return () => window.removeEventListener("resize", updateImageSize);
//   }, [imgSrc]);

//   const updateImageSize = () => {
//     if (!containerRef.current) return;
//     const containerWidth = containerRef.current.clientWidth;
//     const containerHeight = window.innerHeight * 0.8;
//     const aspectRatio = originalSize.width / originalSize.height;

//     let newWidth = containerWidth;
//     let newHeight = newWidth / aspectRatio;

//     if (newHeight > containerHeight) {
//       newHeight = containerHeight;
//       newWidth = newHeight * aspectRatio;
//     }

//     setImageSize({ width: newWidth, height: newHeight });
//   };

//   const handleCanvasClick = () => {
//     if (!stageRef.current) return;

//     const stage = stageRef.current.getStage();
//     const pointer = stage.getPointerPosition();
//     if (!pointer) return;

//     const stageX = stage.x();
//     const stageY = stage.y();
//     const scaleX = stage.scaleX();
//     const scaleY = stage.scaleY();

//     const adjustedX = (pointer.x - stageX) / scaleX;
//     const adjustedY = (pointer.y - stageY) / scaleY;

//     // Convert to relative coordinates
//     const relativeX = adjustedX / imageSize.width;
//     const relativeY = adjustedY / imageSize.height;

//     const formattedPoints = currentPoints
//       .map((_, i, arr) => (i % 2 === 0 ? { x: arr[i], y: arr[i + 1] } : null))
//       .filter(Boolean);

//     if (formattedPoints.length >= 3) {
//       const firstX = formattedPoints[0].x;
//       const firstY = formattedPoints[0].y;
//       const distance = Math.sqrt((firstX - relativeX) ** 2 + (firstY - relativeY) ** 2);

//       if (distance < 0.01) {
//         const newSelection = {
//           coordinates: [...formattedPoints, { x: firstX, y: firstY }],
//           name: `R${ROICounts}`,
//           id: Math.floor(100 + Math.random() * 900),
//         };

//         const updatedSelections = [...selections, newSelection];
//         setSelections(updatedSelections);
//         setCordinates(updatedSelections);
//         setCurrentPoints([]);
//         setROICounts(prev => prev + 1);
//         return;
//       }
//     }

//     setCurrentPoints([...currentPoints, relativeX, relativeY]);
//   };

//   useEffect(() => {
//     setSelections(Cordinates);
//     if (Cordinates?.length <= 0) {
//       setROICounts(1);
//     } else {
//       setROICounts(getNextRoiName(Cordinates));
//     }
//   }, [Cordinates]);

//   return (
//     <div
//       ref={containerRef}
//       style={{
//         width: "100%",
//         height: "80vh",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         overflow: "hidden",
//       }}
//     >
//       <Stage
//         ref={stageRef}
//         width={imageSize.width}
//         height={imageSize.height}
//         onClick={handleCanvasClick}
//       >
//         <Layer>
//           {konvaImage && (
//             <Image image={konvaImage} width={imageSize.width} height={imageSize.height} />
//           )}

//           {selections.map((selection, idx) => {
//             const pointsArray = selection.coordinates
//               .map(({ x, y }) => [x * imageSize.width, y * imageSize.height])
//               .flat();

//             const firstPoint = selection.coordinates[0];

//             return (
//               <React.Fragment key={idx}>
//                 <Line points={pointsArray} stroke="blue" strokeWidth={2} closed />
//                 <Text
//                   x={firstPoint.x * imageSize.width}
//                   y={firstPoint.y * imageSize.height}
//                   text={selection.name}
//                   fontSize={16}
//                   fill="red"
//                   fontStyle="bold"
//                 />
//               </React.Fragment>
//             );
//           })}

//           {currentPoints.length > 2 && (
//             <Line
//               points={currentPoints.map((p, i) =>
//                 i % 2 === 0 ? p * imageSize.width : p * imageSize.height
//               )}
//               stroke="red"
//               strokeWidth={2}
//             />
//           )}

//           {currentPoints.map((point, index) =>
//             index % 2 === 0 ? (
//               <Circle
//                 key={index}
//                 x={point * imageSize.width}
//                 y={currentPoints[index + 1] * imageSize.height}
//                 radius={5}
//                 fill="red"
//               />
//             ) : null
//           )}
//         </Layer>
//       </Stage>
//     </div>
//   );
// };

// export default GetCoordinates;

